import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstancePreviewComponent } from './instance-preview.component';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  declarations: [
    InstancePreviewComponent
  ],
  imports: [
    CommonModule,
    MatBadgeModule
  ],
  exports: [
    InstancePreviewComponent
  ]
})
export class InstancePreviewModule {}
